import React, { useState } from "react";

export const FAQSection = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            question:
                "How much does it cost to list a tool? Is it a one-time payment or a recurring payment?",
            answer: "It costs $29 to list a tool. This is a one-time payment and once complete your tool will be listed forever.",
        },
        {
            question:
                "How long does it take to be listed after I pay and submit?",
            answer: "After successful submission and payment, we will list them within 48 hours and add Features based on time planning.",
        },
        {
            question: "Does my listing expire?",
            answer: "No, your listing will never expire. Once the tool is published on our directory it will remain there indefinitely.",
        },
        {
            question: "What is the refund policy?",
            answer: "We guarantee a full, automatic refund if your tool doesn't get published.",
        },
    ];

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="mt-16">
            <h2 className="text-2xl font-bold text-gray-900 mb-8">
                Frequently Asked Questions
            </h2>
            <div className="space-y-4">
                {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className="border border-gray-200 rounded-lg overflow-hidden"
                    >
                        <button
                            className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 focus:outline-none"
                            onClick={() => toggleFAQ(index)}
                        >
                            <span className="font-medium text-gray-900">
                                {faq.question}
                            </span>
                            <svg
                                className={`w-5 h-5 text-gray-500 transform transition-transform ${
                                    openIndex === index ? "rotate-180" : ""
                                }`}
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M19 9l-7 7-7-7"
                                />
                            </svg>
                        </button>
                        {openIndex === index && (
                            <div className="px-6 pb-4">
                                <p className="text-gray-600">{faq.answer}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
